import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  viewChild,
} from '@angular/core';

import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FieldOkComponent } from '@softline/dynamic';
import { DefaultFieldOkConfiguration } from '../field-ok-configuration';
import { FieldOkWrapper } from '../field-ok-wrapper';

@Component({
  selector: 'soft-subnummer-field-ok',
  imports: [FieldOkComponent],
  templateUrl: './subnummer-field-ok.component.html',
  styleUrl: './subnummer-field-ok.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SubnummerFieldOkComponent),
      multi: true,
    },
  ],
})
export class SubnummerFieldOkComponent
  extends FieldOkWrapper<DefaultFieldOkConfiguration>
  implements ControlValueAccessor
{
  readonly fieldOkComponent = viewChild.required(FieldOkComponent);
  override readonly value = input<object | null>(null);
  override readonly configuration = input<DefaultFieldOkConfiguration | null>(null);
  override readonly parameters = input<object>({});
  override readonly readonly = input<boolean>(false);
  readonly placeholder = input<string | null | undefined>(null);
}
